<script setup lang="ts">
import Modal from './Modal.vue'
import { Button, Spinner } from './ui'

defineProps<{
  open: boolean
  title: string
  hint?: string
  content: string
  loading?: boolean
  error?: string
}>()

const emit = defineEmits<{ close: [] }>()
</script>

<template>
  <Modal :open="open" :title="title" :hint="hint" width="max-w-2xl" @close="emit('close')">
    <template #footer>
      <Button @click="emit('close')">关闭</Button>
    </template>
    <div v-if="loading" class="flex items-center justify-center gap-2 py-12 text-muted">
      <Spinner :size="16" />
      <span class="text-[13px]">加载中…</span>
    </div>
    <p
      v-else-if="error"
      role="alert"
      class="rounded-md border border-danger/40 bg-danger/10 px-3 py-2 text-[12.5px] text-danger"
    >
      {{ error }}
    </p>
    <pre
      v-else
      class="max-h-[55vh] overflow-auto rounded-md border border-line bg-raised/60 p-3 font-mono text-[12px] leading-relaxed whitespace-pre-wrap text-text"
    >{{ content || '（空）' }}</pre>
  </Modal>
</template>
